import React from 'react';
import { Editor, EditorProps } from '@monaco-editor/react';

import { useColorScheme } from 'hooks/useColorScheme';
import { Button } from 'components/Button/Button';

import { Assistant } from 'pipelines/components/CodeEditor/Assistant';
import { Icon } from 'components/Icon/Icon';
import { IconButton } from 'components/IconButton/IconButton';

type CodeEditorProps = EditorProps & {
  disabled?: boolean;
};

export function CodeEditor({
  value,
  onChange,
  disabled: readOnly,
}: CodeEditorProps) {
  const colorScheme = useColorScheme();

  const [isAssistantOpen, setIsAssistantOpen] = React.useState(false);

  return (
    <div
      className={`grid ${isAssistantOpen ? 'grid-cols-2 gap-2' : 'grid-cols-1'}`}
    >
      <div className="relative">
        <Editor
          className="rounded-md border border-gray-200 dark:border-none"
          language="python"
          value={value}
          onChange={onChange}
          width="100%"
          height="50vh"
          theme={colorScheme === 'dark' ? 'vs-dark' : 'light'}
          options={{
            fontSize: 13,
            tabSize: 2,
            stickyScroll: { enabled: false },
            scrollBeyondLastLine: false,
            minimap: { enabled: !isAssistantOpen },
            readOnly,
          }}
        />
        {!isAssistantOpen && (
          <div className="absolute right-8 bottom-4 z-10">
            <Button
              variant="tertiary"
              size="small"
              onClick={() => setIsAssistantOpen(true)}
            >
              <Icon name="logo" size="small" />
              <span>Ask AI</span>
            </Button>
          </div>
        )}
      </div>
      {isAssistantOpen && (
        <div className="relative h-[50vh]">
          <div className="absolute top-4 right-4 z-10">
            <IconButton
              icon="cancel"
              label="Close assistant"
              size="small"
              onClick={() => setIsAssistantOpen(false)}
            />
          </div>
          <Assistant functionNodeCode={value} />
        </div>
      )}
    </div>
  );
}
